import React from "react";
import Spinner from "react-bootstrap/Spinner";

function CheckInButton(props) {

    var checkedIn = props?.checkedIn ?? false

    const [isLoading, setIsLoading] = React.useState(false)

    React.useEffect(() => {
        setIsLoading(false)
    }, [props.checkedIn])

    const handleClick = (e) => {
        e.preventDefault()
        setIsLoading(!isLoading)
        if (props.onCheckIn) {
            props.onCheckIn()
        }
    }
    return (

        <button
        className={"btn " + (checkedIn ? "btn-success" : "btn-outline-primary")}
        onClick={handleClick}
        >
            {checkedIn ? "✔" : "Check In"}
            {isLoading && (
                <Spinner
                animation="border"
                size="sm"
                role="status"
                aria-hidden={true}
                className="ml-2"
                >
                </Spinner>
            )}
        </button>
    )
}

export default CheckInButton